import React from 'react'
import './Experineces.css'
import { themeContext } from '../../Context';
import { useContext } from "react";
function Experineces() {
  const theme=useContext(themeContext);
  const darkMode=theme.state.darkMode;
  return (
         <div className="experiences" id='coding'>
           <div className="achievement">
            <div className="circle">1.5k+</div>
            <span style={{color:darkMode?'white':''}}>DSA problem</span>
            <span>Solved</span>
           </div>

           <div className="achievement">
            <div className="circle">20+</div>
            <span  style={{color:darkMode?'white':''}}>completed</span>
            <span>Projects</span>
           </div>

           <div className="achievement">
            <div className="circle">1,581</div>
            <span style={{color:darkMode?'white':''}}>Heighest Rating </span>
            <span>Leetcode</span>
           </div>
           <div className="achievement">
            <div className="circle">GFG</div>
            <span style={{color:darkMode?'white':''}}>250 University Rank </span>
            <span>
            <a href='https://auth.geeksforgeeks.org/user/ranjeet16pd/'><button className='button'>GFG</button></a>
            </span>
           </div>
           <div className="achievement">
            <div className="circle">
              <h3>Leetcode</h3>
            </div>
            <span style={{color:darkMode?'white':''}}>4 Star</span>
            <span>
              <a href='https://leetcode.com/Ranjeet80/'><button className='button'>Leetcode</button></a>
              
            </span>
           </div>




         </div>
  )
}

export default Experineces
